import { Receipt, ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Label } from "@/components/ui/label";

const STATUS = { "Da ritirare": "bg-emerald-500/15 text-emerald-400 border-emerald-500/30", Ritirato: "bg-slate-500/15 text-slate-300 border-slate-500/30", Scaduto: "bg-red-500/15 text-red-400 border-red-500/30" };
const fmt = (iso) => new Date(iso).toLocaleDateString("it-IT", { timeZone: "Europe/Rome" });

export function CustomerReceipts({ receipts, onOpen }) {
  return (
    <div className="space-y-2" data-testid="customer-receipts">
      <Label className="flex items-center gap-2"><Receipt className="h-4 w-4" /> Ricevute premio del cliente</Label>
      {receipts.length === 0 ? (
        <p className="text-sm text-muted-foreground" data-testid="customer-receipts-empty">Nessuna ricevuta premio per questo numero.</p>
      ) : (
        <ul className="space-y-2" data-testid="customer-receipts-list">
          {receipts.map((r) => (
            <li key={r.serial} className={`rounded-lg border border-border p-3 space-y-1 ${r.status !== "Da ritirare" ? "opacity-60" : ""}`} data-testid={`customer-receipt-${r.serial}`}>
              <div className="flex items-center gap-2 flex-wrap">
                <span className="font-mono-code font-bold">{r.serial}</span>
                <Badge className={`border ${STATUS[r.status] || ""}`} data-testid={`customer-receipt-status-${r.serial}`}>{r.status}</Badge>
                {r.expires_at_local && <span className="text-xs text-muted-foreground ml-auto">Scade il {r.expires_at_local}</span>}
              </div>
              <p className="text-sm">{r.prize_name}</p>
              <p className="text-xs text-muted-foreground">{r.contest_name} · giocata il {fmt(r.played_at)}{r.redeemed_at && ` · ritirato presso ${r.redeemed_store_name}`}</p>
              <Button size="sm" variant="secondary" className="w-full gap-2" onClick={() => onOpen?.(r.serial)} data-testid={`customer-receipt-open-${r.serial}`}>
                <ExternalLink className="h-4 w-4" /> {r.status === "Da ritirare" ? "Apri e invia OTP di ritiro" : "Apri ricevuta"}
              </Button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
